// Aviso da Invasão de Noxara no canto da tela: contagem para começar (na última hora) e para acabar.
import { useEffect, useState } from 'preact/hooks';

export interface InvasionState { active: boolean; ends: number; next: number; minLevel: number; maxLevel: number }

const mmss = (ms: number) => { const s = Math.max(0, Math.round(ms / 1000)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`; };

export function InvasionTag(props: { st: InvasionState | null }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const st = props.st;
  if (!st) return null;
  if (st.active) return (
    <div class="gv-invasion on" title={`A cidade, fora do templo, está tomada por monstros das hunts de level ${st.minLevel} a ${st.maxLevel}. Não há zona protegida fora do templo: magias em área e PvP valem. XP e loot normais.`}>
      ⚔ INVASÃO DE NOXARA · termina em {mmss(st.ends - now)}
    </div>
  );
  if (st.next && st.next - now > 0 && st.next - now <= 3600_000) return (
    <div class="gv-invasion" title={`Monstros das hunts de level ${st.minLevel} a ${st.maxLevel} vão tomar a cidade, fora do templo.`}>Invasão de Noxara em {mmss(st.next - now)}</div>
  );
  return null;
}
